import React, { useState } from 'react';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Footer from '../components/footer';
import EventImageSlider from '../components/EventImageSlider';
import EventModal from '../components/EventModal';

// Images (using existing image variables for demonstration)
import poster from '../assets/Imageslider/Eventpage/poster.jpg';
import day1a from '../assets/Imageslider/Eventpage/day1a.jpg';
import day1b from '../assets/Imageslider/Eventpage/day1b.jpg';

//inaug
import inaug1 from '../assets/Imageslider/Eventpage/inag1.jpg';
import inaug2 from '../assets/Imageslider/Eventpage/inag2.jpg';
import inaug3 from '../assets/Imageslider/Eventpage/inag3.jpg';

//day2
import day2a from '../assets/Imageslider/Eventpage/d.jpg';
import day2b from '../assets/Imageslider/Eventpage/g.jpg';
import day2c from '../assets/Imageslider/Eventpage/p.jpg';
import day2d from '../assets/Imageslider/Eventpage/q.jpg';

// Image arrays
const inaugurationImages = [inaug1, inaug2, inaug3];
const day1Images = [poster, day1a, day1b];
const day2Images = [day2a, day2b, day2c, day2d];

const Events = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleOpen = (eventKey) => {
    setSelectedEvent(eventKey);
  };

  const handleClose = () => {
    setSelectedEvent(null);
  };

  return (
    <>
      <Header />
      <Navbar />


      {/* CSI Student Chapter Inauguration */}
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="px-6 pt-16 pb-6 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
            <b>CSI Student Chapter Inauguration</b>
          </h4>
          <p className="text-gray-600 text-lg mb-8">
            Central University of Jharkhand | <b>29th December, 2024</b>
          </p>
        </section>
        <section className="flex flex-col md:flex-row items-center gap-6 px-6 py-12">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={inaugurationImages} />
          </div>
          <div className="md:w-1/2 w-full">
            <p className="text-lg text-justify">
             The CSI Student Branch at Central University of Jharkhand was officially inaugurated on 29th November 2024. The virtual ceremony, graced by faculty and students, featured the unveiling of the CSI flag and an inspiring address by Prof. A.K. Nayak. The session highlighted the chapter’s mission, vision, and Student Council, laying the foundation for a thriving technical community on campus. </p>
            <button
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => handleOpen('inauguration')}>
                Know More
            </button>
          </div>
        </section>
      </div>

    {/* Start of Seminar Section */}
    <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-300 mx-4 my-8 overflow-hidden transform transition-transform duration-300 hover:scale-[1.01] hover:brightness-95">
        <section className="px-6 pt-16 pb-6 bg-white text-center">
          <h4 className="text-2xl md:text-3xl font-bold mb-2 text-gray-800">
            <b>Two-Day National Seminar on</b> <br className="md:hidden" />
            <span className="text-gray-600"><b>Cybersecurity in the Age of AI and ML</b></span>
          </h4>
          <p className="text-gray-600 text-lg mb-8">
            Organized by CSI Student Chapter – CUJ | <b>27th & 28th February 2025</b>
          </p>
        </section>

        {/* Day 1 of Seminar */}
        <section className="flex flex-col md:flex-row-reverse items-center gap-6 px-6 py-12 bg-gray-100">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={day1Images} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-black-800 mb-2">
              Day 1: Seminar Inauguration & Paper Presentation
            </h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">
              27th February, 2025
            </h3>
            <p className="text-lg text-justify">
              The first day of the <b>Two-Day National Seminar on Cybersecurity in the Age of AI and ML</b> began with the inauguration of the CSI Student Chapter at Central University of Jharkhand. Distinguished guests and experts in computer science set the tone with thought-provoking insights on the convergence of AI, ML, and security challenges. The keynote address emphasized the importance of resilient systems in an era of digital threats. Students and researchers presented papers—both online and offline—exploring innovations in secure machine learning, data privacy, and threat detection, highlighting the need for robust cybersecurity frameworks in today’s AI-driven world.
            </p>
            <button
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => handleOpen('day1')}
            >
              Know More
            </button>
          </div>
        </section>

        {/* Day 2 of Seminar */}
        <section className="flex flex-col md:flex-row items-center gap-6 px-6 py-12 bg-white">
          <div className="md:w-1/2 w-full">
            <EventImageSlider images={day2Images} />
          </div>
          <div className="md:w-1/2 w-full">
            <h2 className="text-2xl md:text-3xl font-semibold text-black-800 mb-2">
              Day 2: Expert Talks & Valedictory Session
            </h2>
            <h3 className="text-lg md:text-xl font-medium text-gray-600 mb-4">
              28th February, 2025
            </h3>
            <p className="text-lg text-justify">
              The second day focused on domain-specific expert talks that delved into practical aspects of cybersecurity in intelligent systems. Sessions explored advanced topics such as blockchain for secure data integrity, AI-powered threat mitigation, and ethical considerations in autonomous decision-making. <br/>The technical discussions bridged the gap between academic research and real-world application, enriching the participants' understanding of digital defense strategies. The event concluded with a valedictory session that acknowledged contributions, inspired future research, and reinforced the mission to build secure and intelligent digital infrastructures.
            </p>
            <button
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={() => handleOpen('day2')}
            >
              Know More
            </button>
          </div>
        </section>
      </div>

      <Footer />

      {/* Modal Section */}
      {selectedEvent && (
        <EventModal onClose={handleClose}>
          {selectedEvent === 'inauguration' && (
          <>
            <h2 className="text-2xl font-bold mb-4">Inauguration of CSI CUJ Student Branch</h2>
            <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
              <p>
                The inauguration of the CSI Student Branch at Central University of Jharkhand marked a pivotal step toward nurturing a collaborative and innovation-driven technical ecosystem within the campus.
                <b>The virtual ceremony featured the digital unveiling of the CSI flag by chief guest Prof. A.K. Nayak, symbolizing the official launch of the chapter.</b>
                <br/><br/>The session began with address by the Head of the Department and that of the CSI Counsellor, setting an enthusiastic tone for the journey ahead.
              </p>

              <p>
                A detailed presentation, outlining the mission of CSI and the vision of the newly established CUJ Chapter, alongside introduction of the Student Council members who will steer the chapter’s initiatives.
              </p>

              <p>
                <b>Prof. Nayak’s keynote address</b> motivated students to <b>embrace AI, ML, and emerging technologies</b>. While continuously evolving as learners and contributors to the computing domain.
              </p>

              <p>
                The event witnessed active participation from CSE students across all batches, reflecting a strong commitment to future activities.
                The inauguration led the foundation for fostering technical excellence, collaborative learning,
                and professional growth under the banner of CSI at CUJ.
              </p>
            </div>
          </>
        )}

        {selectedEvent === 'day1' && (
        <>
          <h2 className="text-2xl font-bold mb-4">Day 1: Seminar Inauguration & Paper Presentation</h2>
          <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
            {/* ... day1 modal content unchanged (same as your original) */}
            {/* (kept same content as in your original file) */}
          </div>
        </>
    )}

    {selectedEvent === 'day2' && (
      <>
        <h2 className="text-2xl font-bold mb-4">Day 2: Expert Talks & Valedictory Session</h2>
        <div className="text-base text-justify space-y-4 max-h-[70vh] overflow-y-auto pr-2">
          {/* ... day2 modal content unchanged (same as your original) */}
          {/* (kept same content as in your original file) */}
        </div>
      </>
    )}
        </EventModal>
      )}
    </>
  );
};

export default Events;
